export const PaymentEmailEntryHandlebarRegex = /\[paymentEmailEntry\]/g;
export const CopyReferralLinkButtonRegex = /\[referralLinkWithButton\]/g;
export const MoreDetailsReferralButtonRegex = /\[referralLinkReferralProgramButton\]/g;
